module.exports = __webpack_public_path__ + "img/brain.9bfe6be3.svg";